var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.currentValue))])}
var staticRenderFns = []

export { render, staticRenderFns }